import apiClient from 'services/axios'

export async function onBoardingDone(onBoardingStatus) {
  return apiClient
    .get(`/users/onboarding?done=${onBoardingStatus}`)
    .then(response => {
      if (response) {
        console.log('On boarding response', response)
        return true
      }
      return false
    })
    .catch(err => {
      console.log('Error during onboarding process', err)
      return false
    })
}

export async function sendConfirmationEmail() {
  return apiClient
    .get(`/users/confirmation`)
    .then(response => {
      if (response) {
        console.log('Confirmation asked', response)
        return true
      }
      return false
    })
    .catch(err => {
      console.log('Error during confirmation email process', err)
      return false
    })
}

export async function isEmailValidated() {
  return apiClient
    .get(`/users/mail/validated`)
    .then(response => {
      if (response && response.data) {
        const { data } = response.data
        if (data.isEmailValidated) {
          return true
        }
        return false
      }
      return false
    })
    .catch(err => {
      console.log('Error during email validation process', err)
      return false
    })
}
